import React, { useState } from "react"
import styled from "styled-components"
import { withStyles } from "@material-ui/core/styles"
import MuiDialogContent from "@material-ui/core/DialogContent"
import i18n from "../../i18n"

const Container = styled.div`
  margin: auto;
  display: flex;
  flex-direction: column;
  justify-content: space-evenly;
  box-sizing: border-box;
  background-color: transparent;
  text-align: left;
`
const SingleBidBox = styled.div`
  border-radius: 4px;
  background-color: #755eff;
  padding: 25px;
`
const MultipleBidBox = styled.div`
  border-radius: 4px;
  background-color: #c575ff;
  padding: 25px;
`

const BoxTitle = styled.p`
  font-family: "montserratRegular";
  color: #fff;
  font-size: 18px;
  margin: 0;
`

const BoxSubTitle = styled.p`
  font-family: "montserratLight";
  color: #fff;
  font-size: 14px;
`

const OR = styled.div`
  width: 48px;
  height: 48px;
  margin: auto;
  background-color: #474853;
  font-family: "montserratRegular";
  color: #fff;
  border-radius: 50%;
  display: flex;
  justify-content: center;
  align-items: center;
  margin: 30px auto;
  cursor: pointer;
`

const BidButton = styled.div`
  min-width: 280px;
  width: 100%;
  height: 56px;
  border-radius: 30px;
  background-color: #fff;
  box-sizing: border-box;
  color: #fb0e56;
  font-family: "montserratRegular";
  margin: 20px auto;
  display: flex;
  justify-content: center;
  align-items: center;
  margin-bottom: 0;
  cursor: pointer;
`

const Input = styled.input`
  border-radius: 4px;
  background-color: #231d47;
  padding: 10px;
  border: none;
  box-sizing: border-box;
  box-shadow: none;
  outline: none;
  height: 50px;
  width: 100%;
  color: #fff;
`

// const DialogContent = withStyles((theme) => ({
//   root: {
//     background: "transparent",
//   },
// }))(MuiDialogContent)

const index = ({ onClick, data }) => {
  const [singleBidValue, setSingleBidValue] = useState()
  console.log("singleBidValue", singleBidValue)
  return (
    // <DialogContent>
    <Container>
      {/* <SingleBidBox>
        <BoxTitle>Single Bid</BoxTitle>
        <BoxSubTitle>You can bid only one here</BoxSubTitle>
        <Input
          type='number'
          step='any'
          onChange={(e) => setSingleBidValue(e.target.value)}
          value={singleBidValue}
        />
        <BidButton onClick={() => onClick(data, singleBidValue)}>
          Place Bid
        </BidButton>
      </SingleBidBox>
      <OR>OR</OR> */}
      <MultipleBidBox>
        <BoxTitle>{i18n.t("MultipleBids")}</BoxTitle>
        <BoxSubTitle>{i18n.t("YouBidMore")}</BoxSubTitle>
        <BidButton onClick={() => onClick(data)}>
          {i18n.t("ChooseBid")}
        </BidButton>
      </MultipleBidBox>
    </Container>
    // </DialogContent>
  )
}

export default index



// WEBPACK FOOTER //
// ./src/components/BidType/index.js